(function () {
  const CUSTOM_FIT_VALUE = 'custom fit';
  const OPTION_ROOT_SELECTOR = [
    '[class*="easify" i]',
    '[id*="easify" i]',
    '[data-app*="easify" i]',
    '[data-app-name*="easify" i]',
    '[class^="epo" i]',
    '[id^="epo" i]',
    '[class*=" epo" i]',
    '[id*=" epo" i]',
    '[class*="easify-options" i]',
    '[id*="easify-options" i]',
  ].join(',');
  const EMBROIDERY_LABELS = [
    'embroidery',
    'embroidery placement',
    'embroidery position',
    'embroidery content',
    'image upload',
  ];

  let observer;
  let scheduled = false;

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function isSizeOptionName(name) {
    const normalized = normalize(name);
    return normalized.includes('size') || normalized.includes('尺码') || normalized.includes('尺寸');
  }

  function getSelectedSizeValue() {
    const pickers = document.querySelectorAll('variant-selects .product-form__input[data-option-name]');

    for (const picker of pickers) {
      if (!isSizeOptionName(picker.dataset.optionName)) continue;

      const select = picker.querySelector('select');
      if (select) return normalize(select.value);

      const checked = picker.querySelector('input[type="radio"]:checked:not([data-size-group-control])');
      if (checked) return normalize(checked.value);

      const selectedText = picker.querySelector('[data-selected-swatch-value]');
      if (selectedText) return normalize(selectedText.textContent);
    }

    return '';
  }

  function textMatchesEmbroidery(text) {
    const normalized = normalize(text);
    return EMBROIDERY_LABELS.some((label) => normalized.includes(label));
  }

  function findOptionRoot(element) {
    const pluginRoot = element.closest(OPTION_ROOT_SELECTOR);
    if (!pluginRoot) return null;
    if (pluginRoot.matches('product-info, variant-selects, form[is="product-form"]')) return null;
    if (pluginRoot.closest('variant-selects')) return null;

    return pluginRoot;
  }

  function getEmbroideryContainers() {
    const roots = new Set();

    document.querySelectorAll(OPTION_ROOT_SELECTOR).forEach((element) => {
      if (!element.matches('product-info, variant-selects') && textMatchesEmbroidery(element.textContent)) {
        roots.add(element);
      }
    });

    document.querySelectorAll('label, legend, strong, b, span, p').forEach((element) => {
      if (!textMatchesEmbroidery(element.textContent)) return;
      const root = findOptionRoot(element);
      if (root) roots.add(root);
    });

    return Array.from(roots).filter((element) => {
      const nestedRoot = Array.from(roots).some((root) => root !== element && root.contains(element));
      return !nestedRoot;
    });
  }

  function setDisabled(container, disabled) {
    container.querySelectorAll('input, select, textarea, button').forEach((control) => {
      if (disabled) {
        if (control.disabled) {
          control.dataset.customFitEmbroideryWasDisabled = 'true';
        }
        if (!control.disabled) control.disabled = true;
      } else if (control.dataset.customFitEmbroideryWasDisabled !== 'true') {
        if (control.disabled) control.disabled = false;
      }

      if (!disabled) {
        delete control.dataset.customFitEmbroideryWasDisabled;
      }
    });
  }

  function updateEmbroideryVisibility() {
    scheduled = false;
    observer.disconnect();

    const showEmbroidery = getSelectedSizeValue().includes(CUSTOM_FIT_VALUE);
    getEmbroideryContainers().forEach((container) => {
      if (container.hidden === showEmbroidery) container.hidden = !showEmbroidery;

      const ariaHidden = showEmbroidery ? 'false' : 'true';
      if (container.getAttribute('aria-hidden') !== ariaHidden) {
        container.setAttribute('aria-hidden', ariaHidden);
      }

      container.classList.toggle('custom-fit-embroidery-hidden', !showEmbroidery);
      setDisabled(container, !showEmbroidery);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateEmbroideryVisibility);
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) scheduleUpdate();
  });
  document.addEventListener('variant:changed', scheduleUpdate);
  document.addEventListener('shopify:section:load', scheduleUpdate);
  document.addEventListener('DOMContentLoaded', scheduleUpdate);

  observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  scheduleUpdate();
})();
